import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Alert, AlertIcon, Text, CloseButton } from '@chakra-ui/react'
import { Editor } from '@/components/editor'
import { generateCopyFilename } from '@/lib/utils/filename'

interface LocationState {
  prefillContent?: string
  prefillFilename?: string
}

export function HomePage() {
  const location = useLocation()
  const locationState = location.state as LocationState | null
  const [showEditAlert, setShowEditAlert] = useState(false)
  const [initialContent, setInitialContent] = useState('')
  const [initialFilename, setInitialFilename] = useState('untitled')
  const [editorKey, setEditorKey] = useState(0)

  // Handle prefilled content from edit mode
  useEffect(() => {
    if (locationState?.prefillContent) {
      setInitialContent(locationState.prefillContent)
      setInitialFilename(generateCopyFilename(locationState.prefillFilename))
      setShowEditAlert(true)
      // Increment key to force Editor to remount with new content
      setEditorKey(prev => prev + 1)
      // Clear the state so refreshing doesn't re-prefill
      window.history.replaceState({}, document.title)
    }
  }, [locationState])

  return (
    <Box flex={1} display="flex" flexDirection="column" overflow="hidden" minH={0}>
      {showEditAlert && (
        <Alert status="info" borderRadius={0} flexShrink={0}>
          <AlertIcon />
          <Box flex="1">
            <Text fontWeight="medium">Content loaded from edited share</Text>
            <Text fontSize="sm">
              Make any additional changes and create a new share when ready.
            </Text>
          </Box>
          <CloseButton onClick={() => setShowEditAlert(false)} />
        </Alert>
      )}
      <Box flex={1} display="flex" overflow="hidden" minH={0}>
        <Editor
          key={editorKey}
          initialContent={initialContent}
          initialFilename={initialFilename}
        />
      </Box>
    </Box>
  )
}
